import { render, staticRenderFns } from "./DeleteFlow.vue?vue&type=template&id=64e9a2bc&"
import script from "./DeleteFlow.vue?vue&type=script&lang=js&"
export * from "./DeleteFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports